import React from 'react';

const CautionIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
      <path d="M5 0L0 9H10L5 0Z" fill="#FF3E41" />
    </svg>
  );
};

export default CautionIcon;
